/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_Rate_ReviewInputs */

const en_orders_carrier_rate_review = /** @type {(inputs: Orders_Carrier_Rate_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier changed. Shipping rate needs review.`)
};

const es_orders_carrier_rate_review = /** @type {(inputs: Orders_Carrier_Rate_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se cambio el transportista. La tarifa de envio necesita revision.`)
};

/**
* | output |
* | --- |
* | "Carrier changed. Shipping rate needs review." |
*
* @param {Orders_Carrier_Rate_ReviewInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_rate_review = /** @type {((inputs?: Orders_Carrier_Rate_ReviewInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Rate_ReviewInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_rate_review(inputs)
	return es_orders_carrier_rate_review(inputs)
});